import agenda2 from '@/assets/img/icons/ico_agenda2.svg'
import agendaEngrenagem from '@/assets/img/icons/ico_agenda-engrenagem.svg'
import agenda from '@/assets/img/icons/ico_agenda.svg'
import avaliacoes from '@/assets/img/icons/ico-avaliacoes.svg'
import consultareagenda from '@/assets/img/icons/ico-consultareagenda.svg'
import dadosBancarios from '@/assets/img/icons/ico_dados-bancarios.svg'
import dashAtendidos from '@/assets/img/icons/ico-dash-atendidos.svg'
import dashCalendar from '@/assets/img/icons/ico_dash-calendar.svg'
import dashCanceladas from '@/assets/img/icons/ico-dash-canceladas.svg'
import dashDuracao from '@/assets/img/icons/ico-dash-duracao.svg'
import endoscopia from '@/assets/img/icons/ico_endoscopia.svg'
import excluiAlerta from '@/assets/img/icons/ico_exclui-alerta.svg'
import extrato from '@/assets/img/icons/ico_extrato.svg'
import fechar from '@/assets/img/icons/ico_fechar.svg'
import historico from '@/assets/img/icons/ico_historico.svg'
import homograma from '@/assets/img/icons/ico_homograma.svg'
import imprimir from '@/assets/img/icons/ico_imprimir.svg'
import logout from '@/assets/img/icons/ico-logout.svg'
import lupaAgenda from '@/assets/img/icons/ico_lupa-agenda.svg'
import lupaForm from '@/assets/img/icons/ico_lupa-form.svg'
import lupa from '@/assets/img/icons/ico_lupa.svg'
import notification from '@/assets/img/icons/ico-notification.svg'
import novaconsulta from '@/assets/img/icons/ico-novaconsulta.svg'
import pacientes from '@/assets/img/icons/ico_pacientes.svg'
import pagamento from '@/assets/img/icons/ico_pagamento.svg'
import painel from '@/assets/img/icons/ico_painel.svg'
import radiografia from '@/assets/img/icons/ico-radiografia.svg'
import precos from '@/assets/img/icons/ico_precos.svg'
import starAvaliacao from '@/assets/img/icons/ico_star_avaliacao.svg'
import star from '@/assets/img/icons/ico_star.svg'
import starFull from '@/assets/img/icons/ico_star_full.svg'
import timer from '@/assets/img/icons/ico_timer.svg'
import tomografia from '@/assets/img/icons/ico-tomografia.svg'
import ultrassom from '@/assets/img/icons/ico_ultrassom.svg'
import upload from '@/assets/img/icons/ico-upload.svg'
import file from '@/assets/img/icons/ico_file.svg'
import consultas from '@/assets/img/icons/ico_consultas.svg'
import usuarios from '@/assets/img/icons/ico_usuarios.svg'
import procedimentos from '@/assets/img/icons/ico_procedimentos.svg'
import edit from '@/assets/img/icons/ico_edit.svg'
import money from '@/assets/img/icons/ico_money.svg'
import check from '@/assets/img/icons/ico-check.svg'
import time from '@/assets/img/icons/ico-time.svg'
import user from '@/assets/img/icons/ico-user.svg'
import info from '@/assets/img/icons/ico-info.svg'
import plans from '@/assets/img/icons/ico-plans.svg'
import reports from '@/assets/img/icons/ico_relatorios.svg'
import visibilityOn from '@/assets/img/icons/ico_visibility.svg'
import visibilityOff from '@/assets/img/icons/ico_visibility_off.svg'
import help from '@/assets/img/icons/ico-help.svg'
import widgetCalendar from '@/assets/img/icons/ico-widgetCalendar.svg'
import widgetClose from '@/assets/img/icons/ico-widgetClose.svg'
import widgetTick from '@/assets/img/icons/ico-widgetTick.svg'
import maintenance from '@/assets/img/icons/ico_maintenance.svg'
import smiley from '@/assets/img/icons/ico-smiley.svg'
import fileMedical from '@/assets/img/icons/ico-file_medical.svg'
import userTimes from '@/assets/img/icons/ico-user_times.svg'
import google from '@/assets/img/icons/ico-google.svg'
import telephone from '@/assets/img/icons/ico_telephone.svg'
import category from '@/assets/img/icons/ico_category.svg'
import categoryAlt from '@/assets/img/icons/ico-category-2.svg'
import referral from '@/assets/img/icons/ico_referral.svg'
import clock from '@/assets/img/icons/ico_clock.svg'
import note from '@/assets/img/icons/ico_note.svg'
import healthInsuranceCard from '@/assets/img/icons/ico_healthInsuranceCard.svg'
import dollar from '@/assets/img/icons/ico_dollar.svg'
import email from '@/assets/img/icons/ico_email.svg'
import cpf from '@/assets/img/icons/ico_cpf.svg'
import map from '@/assets/img/icons/ico_map.svg'
import birthday from '@/assets/img/icons/ico_birthday.svg'
import person from '@/assets/img/icons/ico_person.svg'
import payment from '@/assets/img/icons/ico_payment.svg'
import calendar from '@/assets/img/icons/ico_calendar.svg'
import medicalService from '@/assets/img/icons/ico_exameProcedure.svg'
import rg from '@/assets/img/icons/ico_rg.svg'
import sus from '@/assets/img/icons/ico_sus.svg'
import trash from '@/assets/img/icons/ico-trash.svg'
import startTelemedicine from '@/assets/img/icons/ico-start-telemedicine.svg'
import videoOn from '@/assets/img/icons/ico-video-on.svg'
import videoOff from '@/assets/img/icons/ico-video-off.svg'
import micOn from '@/assets/img/icons/ico-mic-on.svg'
import micOff from '@/assets/img/icons/ico-mic-off.svg'
import fullscreen from '@/assets/img/icons/ico-fullscreen.svg'
import disconnect from '@/assets/img/icons/ico-disconnect.svg'
import changeOffice from '@/assets/img/icons/ico-changeOffice.svg'
import appIntegration from '@/assets/img/icons/ico-app-integration.svg'
import inpersonOffice from '@/assets/img/icons/ico-inperson-office.svg'
import inpersonAppointment from '@/assets/img/icons/ico-inperson-appointment.svg'
import telemedicineOffice from '@/assets/img/icons/ico-telemedicine-office.svg'
import telemedicineAppointment from '@/assets/img/icons/ico-telemedicine-appointment.svg'
import copy from '@/assets/img/icons/ico-copy.svg'
import whatsapp from '@/assets/img/icons/ico-whatsapp.svg'
import visitLink from '@/assets/img/icons/ico-visit-link.svg'
import name from '@/assets/img/icons/ico-name.svg'
import receipt from '@/assets/img/icons/ico-receipt.svg'
// novos
import menuAgenda from '@/assets/img/icons/ico-menu-agenda.svg'
import menuAgendamentos from '@/assets/img/icons/ico-menu-agendamentos.svg'
import menuConta from '@/assets/img/icons/ico-menu-conta.svg'
import menuExtrato from '@/assets/img/icons/ico-menu-extrato.svg'
import menuHistorico from '@/assets/img/icons/ico-menu-historico.svg'
import menuModelos from '@/assets/img/icons/ico-menu-modelos.svg'
import menuPacientes from '@/assets/img/icons/ico-menu-pacientes.svg'
import menuRelatorios from '@/assets/img/icons/ico-menu-relatorios.svg'
import menuServicos from '@/assets/img/icons/ico-menu-servicos.svg'
import menuHealthplace from '@/assets/img/icons/ico-menu-healthplace.svg'
import agendaShare from '@/assets/img/icons/ico_agenda_share.svg'
import adobe from '@/assets/img/icons/ico-adobe.svg'
import image from '@/assets/img/icons/ico-image.svg'
import verifiedDoc from '@/assets/img/icons/ico-verified-doc.svg'
import verifiedDocGray from '@/assets/img/icons/ico-verified-doc-gray.svg'
import cloudDownload from '@/assets/img/icons/ico_cloud-download.svg'
import padlock from '@/assets/img/icons/ico-padlock.svg'
import checkAlt from '@/assets/img/icons/ico-check-alt.svg'
import bell from '@/assets/img/icons/ico-bell.svg'
import exclamation from '@/assets/img/icons/ico-exclamation.svg'
import planPremium from '@/assets/img/icons/ico-plano-premium.svg'
import coupon from '@/assets/img/icons/ico-coupon.svg'
import cardChip from '@/assets/img/icons/ico-card-chip.svg'
import checkoutSuccess from '@/assets/img/icons/ico-assinatura-sucesso.svg'

export default {
  agenda2,
  agendaEngrenagem,
  agenda,
  avaliacoes,
  consultas,
  consultareagenda,
  dadosBancarios,
  dashAtendidos,
  dashCalendar,
  dashCanceladas,
  dashDuracao,
  endoscopia,
  excluiAlerta,
  extrato,
  fechar,
  historico,
  homograma,
  imprimir,
  logout,
  lupaAgenda,
  lupaForm,
  lupa,
  notification,
  novaconsulta,
  pacientes,
  pagamento,
  painel,
  radiografia,
  precos,
  starAvaliacao,
  star,
  starFull,
  timer,
  tomografia,
  ultrassom,
  usuarios,
  upload,
  file,
  procedimentos,
  edit,
  money,
  check,
  time,
  user,
  info,
  plans,
  reports,
  visibilityOn,
  visibilityOff,
  help,
  widgetCalendar,
  widgetClose,
  widgetTick,
  maintenance,
  smiley,
  fileMedical,
  userTimes,
  google,
  telephone,
  category,
  categoryAlt,
  referral,
  clock,
  note,
  healthInsuranceCard,
  dollar,
  email,
  cpf,
  map,
  birthday,
  person,
  payment,
  calendar,
  medicalService,
  rg,
  sus,
  trash,
  startTelemedicine,
  videoOn,
  videoOff,
  micOn,
  micOff,
  fullscreen,
  disconnect,
  changeOffice,
  appIntegration,
  inpersonAppointment,
  inpersonOffice,
  telemedicineAppointment,
  telemedicineOffice,
  copy,
  whatsapp,
  visitLink,
  name,
  receipt,
  menuAgenda,
  menuAgendamentos,
  menuConta,
  menuExtrato,
  menuHistorico,
  menuModelos,
  menuPacientes,
  menuRelatorios,
  menuServicos,
  menuHealthplace,
  agendaShare,
  adobe,
  image,
  verifiedDoc,
  verifiedDocGray,
  cloudDownload,
  padlock,
  checkAlt,
  bell,
  exclamation,
  planPremium,
  coupon,
  cardChip,
  checkoutSuccess
}
